import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import axios from "src/app/Service/axios";
import { DeviceDetectorService } from 'ngx-device-detector';
import { OtherService } from "src/app/Service/other.service";
import { map, Observable, of } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';


@Component({

  selector: 'app-dashboard-combined',

  templateUrl: './dashboard-combined.component.html',

})

export class DashboardCombinedComponent implements OnInit {

  isDesktop: any;

  options!: Observable<any>;

  options1!: Observable<any>;

  options2!: Observable<any>;

  options3!: Observable<any>;

  options4!: Observable<any>;

  constructor(private router: Router, private deviceDetector: DeviceDetectorService, private otherService: OtherService, private gurdService: GurdServiceService) { }

  ngOnInit(): void {
    this.isDesktop = this.deviceDetector.isDesktop();
    this.loadTree1('Tree_MobilesStatistics');
    this.loadTree2('Tree_MobilesStatus');
    this.loadTree3('Tree_MobilesSerious');
    this.loadTree4('Tree_MobilesAverageLife');
    this.loadTree5('Tree_MobilesCostRpairs');
  }

  loadTree1 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('totalVehicles') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  loadTree2 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options1 = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('orgVehiclesStatus') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  loadTree3 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options2 = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('vehiclefines') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  loadTree4 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options3 = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('vehicleLife') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  loadTree5 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options4 = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('vehicleRepaircost') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  guid(Id: any) {
    this.otherService.guid(Id);
  }

  goBack() {
    this.router.navigateByUrl(`/`);;
  }

}
